import PageTemplate from "../components/PageTemplate";
import Content from "../components/Content";
import Divider from "../components/Divider";
import { Accordion } from "radix-ui";
import { ChevronDownIcon } from '@radix-ui/react-icons';
import PageFade from "../motions/PageFade";
import { useEffect } from 'react';

const lineDetails = [
  // "Choose between 1 King bed or 2 Queen beds",
  "This hotel is a 9-minute walk to the wedding venue; 5 minutes by car",
  // "The closest hotel possible to the wedding venue",
  "Easy to explore D.C.",
  "Pets are welcome free of charge",
  "Breakfast not included",
  "Complimentary Wi-fi",
  "Parking: $55 nightly rate; $35 daily rate",
];

// const hiltonDetails = [
//   "Choose between 1 King bed or 2 Double beds",
//   "This hotel is a 15-minute walk to the wedding venue; 5-10 minutes by car",
//   "Lots of restaurants, shopping, attractions, and transportation options nearby",
//   "Easy to explore D.C.",
//   "Breakfast not included",
//   "Wi-fi is normally $12.95, but is free if booking as part of our courtesy block",
//   "Parking: $58 daily rate",
//   "Note: The nightly rate is assuming up to two people per room. But if you want more people staying in your room, you could always check-in as only two people since, in practice, they don’t check the actual number of guests."
// ];

const homewoodDetails = [
  "The 1-King Suite includes 1 King bed and 1 Sleeper Sofa (sleeps up to 4 people)",
  "The 2-Queen Suite includes 2 Queen beds and 1 Sleeper Sofa (sleeps up to 6 people)",
  "This hotel is a 15 to 30 minutes drive to the wedding venue, depending on traffic",
  "All guest rooms include a kitchen",
  "Complimentary hot breakfast",
  "Complimentary Wi-fi",
  "Complimentary shuttle service to shops, including Target and Safeway",
  "Parking: $30 daily rate"
];

const westinDetails = [
  "Choose between 1 King bed or 2 Double beds",
  "This hotel is a 20 to 40 minutes drive to the wedding venue, depending on traffic",
  "Lots of restaurants, bars, and shopping within walking distance",
  "Breakfast not included",
  "Complimentary Wi-fi",
  "Parking: $40 daily for self-parking; $48 daily for valet",
  "Note: Guests wanting to check-in on Thursday will have to call the hotel to add that additional night to their reservation. Please mention Duong-Lee Wedding Block."
];

function Hotels() {
  console.log("Hotels rendered");

  useEffect(() => {
    console.log("Hotels mounted");

    return () => {
      console.log("Hotels unmounted");
    };
  }, []);

  return (
    <PageFade>
      <PageTemplate title="Hotels" textColor="text-gold">
        <Content small={true}>
          <div className="mb-10"> {/**Added margin so there is some gap at the bottom of the page */}
            <div className="space-y-6">
              <p>
                Thuyan & Jerry will be staying at The LINE Hotel. Guests are welcome to stay there or book
                any hotel or accommodations that best fit their needs, preferences, and budget.
              </p>
              <p>
                There are many great hotel and Airbnb options throughout the DC area for those who prefer
                alternative accommodations.
              </p>
              <p>
                If you'd like to stay at The LINE Hotel, you can book directly through the hotel website below.
                Please be sure to adjust your check-in and check-out dates as needed.
              </p>
            </div>

            <Divider className={`border-gold border-t w-1/2 mx-auto my-16`} />

            <div className="hotel flex text-center items-center space-y-8 justify-center flex-col">
              <div className="hotel-name text-gold subheading text-2xl lg:text-3xl xl:text-4xl">
                THE LINE HOTEL
              </div>
              <a
                href="https://www.google.com/maps/place/The+LINE+DC/@38.9227591,-77.0442265,898m/data=!3m2!1e3!4b1!4m9!3m8!1s0x89b7b7d9764fbd2b:0xf9cdd9c560db470a!5m2!4m1!1i2!8m2!3d38.9227591!4d-77.0416516!16s%2Fg%2F11c70dyqc4?entry=ttu&g_ep=EgoyMDI1MTEyMy4xIKXMDSoASAFQAw%3D%3D"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline"
              >
                <div className="hotel-address">
                  <p>1770 Euclid St NW,</p>
                  <p>Washington, DC 20009</p>
                  <p>(202) 588-0525</p>
                </div>
              </a>
              <div className="hotel-info">
                <p>0.4 miles from the wedding venue</p>
              </div>
              <div className="hotel-image">
                <img
                  src="/assets/images/hotels/line.jpg"
                  alt="THE LINE HOTEL"
                  className="border border-customGray mx-auto w-96 max-w-full"
                />
              </div>
              <HotelAccordion hotelName="THE LINE HOTEL" details={lineDetails} bookingLink="https://www.thelinehotel.com/dc/" />
            </div>

            {/* <Divider className={`border-gold border-t w-1/2 mx-auto my-16`} /> */}

            {/* <div className="hotel flex text-center items-center space-y-8 justify-center flex-col">
            <div className="hotel-name text-gold subheading text-2xl lg:text-3xl xl:text-4xl">
              WASHINGTON HILTON
            </div>
            <a
              href="https://www.google.com/maps/place/Washington+Hilton/@38.9165712,-77.0454106,1797m/data=!3m2!1e3!4b1!4m9!3m8!1s0x89b7b7c5695815a5:0xb6c0dfbd050cfc75!5m2!4m1!1i2!8m2!3d38.9165712!4d-77.0454106!16s%2Fm%2F02rqgrq?entry=ttu&g_ep=EgoyMDI1MDcwNi4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              <div className="hotel-address">
                <p>1919 Connecticut Ave NW,</p>
                <p>Washington, DC 20009</p>
                <p>(202) 483-3000</p>
              </div>
            </a>
            <div className="hotel-price text-gold">
              <p>$289 per night (plus tax)</p>
            </div>
            <div className="hotel-info">
              <p>Check-in: Thursday or Friday | Check-out: Sunday</p>
              <p>0.8 miles from the wedding venue</p>
              <p>Great choice for guests who want to stay in D.C.</p>
            </div>
            <div className="hotel-image">
              <img
                src="/assets/images/hotels/hilton.png"
                alt="THE WASHINGTON HILTON"
                className="border border-customGray mx-auto w-96 max-w-full"
              />
            </div>
            <HotelAccordion hotelName="THE WASHINGTON HILTON" details={hiltonDetails} bookingLink="https://book.passkey.com/gt/220805200?gtid=b8986055b0f0c8b5e722ec5f8bca4dcd" />
          </div>

          <Divider className={`border-gold border-t w-1/2 mx-auto my-16`} /> */}

            {/* <div className="hotel flex text-center items-center space-y-8 justify-center flex-col">
              <div className="hotel-name text-gold subheading text-2xl lg:text-3xl xl:text-4xl">
                HOMEWOOD SUITES BY HILTON
              </div>
              <a
                href="https://www.google.com/maps/place/Homewood+Suites+by+Hilton+Arlington+Rosslyn+Key+Bridge/@38.8973373,-77.0816309,1842m/data=!3m2!1e3!4b1!4m9!3m8!1s0x89b7b65d8dc5191f:0xb4e7132e0cf140f1!5m2!4m1!1i2!8m2!3d38.8973373!4d-77.079056!16s%2Fg%2F11hbqqh4tx?entry=ttu&g_ep=EgoyMDI1MDcwNi4wIKXMDSoASAFQAw%3D%3D"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline"
              >
                <div className="hotel-address">
                  <p>1900 N Quinn St,</p>
                  <p>Arlington, VA 22209</p>
                  <p>(703) 348-2828</p>
                </div>
              </a>
              <div className="hotel-price text-gold">
                <p>$229 per night (plus tax) for 1-King Suite</p>
                <p>$269 per night (plus tax) for 2-Queen Suite</p>
              </div>
              <div className="hotel-info">
                <p>Check-in: Thursday or Friday | Check-out: Sunday</p>
                <p>4.5 miles from the wedding venue</p>
                <p>Great choice for families or groups who want more space and complimentary breakfast</p>
              </div>
              <div className="hotel-image">
                <img
                  src="/assets/images/hotels/homewood-suites.png"
                  alt="HOMEWOOD SUITES"
                  className="border border-customGray mx-auto w-96 max-w-full"
                />
              </div>
              <HotelAccordion hotelName="HOMEWOOD SUITES" details={homewoodDetails} bookingLink="https://www.hilton.com/en/book/reservation/rooms/?ctyhocn=DCALHHW&arrivalDate=2026-04-24&departureDate=2026-04-26&groupCode=CHW908&room1NumAdults=1&cid=OM%2CWW%2CHILTONLINK%2CEN%2CDirectLink" />
            </div> */}

            {/* <Divider className={`border-gold border-t w-1/2 mx-auto my-16`} />

            <div className="hotel flex text-center items-center space-y-8 justify-center flex-col">
              <div className="hotel-name text-gold subheading text-2xl lg:text-3xl xl:text-4xl">
                WESTIN ARLINGTON
              </div>
              <a
                href="https://www.google.com/maps/place/The+Westin+Arlington/@38.8806466,-77.1168735,921m/data=!3m1!1e3!4m9!3m8!1s0x89b7b43b319e6fef:0xddb854139e45e958!5m2!4m1!1i2!8m2!3d38.8806466!4d-77.1142986!16s%2Fg%2F1tggpj9y?entry=ttu&g_ep=EgoyMDI1MDcwNi4wIKXMDSoASAFQAw%3D%3D"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline"
              >
                <div className="hotel-address">
                  <p>801 N Glebe Rd,</p>
                  <p>Arlington, VA 22203</p>
                  <p>(703) 717-6200</p>
                </div>
              </a>
              <div className="hotel-price text-gold">
                <p>$169 per night (plus tax)</p>
              </div>
              <div className="hotel-info">
                <p>Check-in:  Friday | Check-out: Sunday</p>
                <p>7.6 miles from the wedding venue</p>
                <p>Great choice for couples and young adults</p>
              </div>
              <div className="hotel-image">
                <img
                  src="/assets/images/hotels/westin.png"
                  alt="THE WESTIN ARLINGTON"
                  className="border border-customGray mx-auto w-96 max-w-full"
                />
              </div>
              <HotelAccordion hotelName="THE WESTIN ARLINGTON" details={westinDetails} bookingLink="https://www.marriott.com/event-reservations/reservation-link.mi?id=1750683956504&key=GRP&app=resvlink " />
            </div> */}

          </div>
        </Content>
      </PageTemplate>
    </PageFade>
  );
}



const HotelAccordion = ({ details, hotelName, bookingLink }) => (
  <div className="w-full mx-auto">
    <Accordion.Root type="single" collapsible className="w-full border border-rose bg transition transform hover:-translate-y-1 ">
      <Accordion.Item value="details" className="w-full border border-rose">
        <Accordion.Header>
          <Accordion.Trigger className="w-full text-customGray bg-blush hover:text-white hover:bg-rose ">
            <div className="p-3 group flex justify-between items-center">
              <div className="text-center flex-grow">{`DETAILS AND BOOKING LINK FOR ${hotelName}`}</div>
              <ChevronDownIcon
                className="transition-transform duration-200 group-aria-expanded:rotate-180"
                aria-hidden
              />
            </div>
          </Accordion.Trigger>
        </Accordion.Header>
        <Accordion.Content className="AccordionContent border-t border-rose">
          <div className="p-4">
            <ul className="list-disc pl-6 space-y-2 text-customGray text-left">
              {details.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            <div className="link mt-6 mb-2 text-gold">
              <a
                href={bookingLink}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline hover:cursor-pointer"
              >
                {`CLICK HERE FOR THE WEBSITE OF ${hotelName}`}
              </a>
            </div>
          </div>
        </Accordion.Content>
      </Accordion.Item>
    </Accordion.Root>
  </div>
);



export default Hotels;
